import React, { Component } from "react";

class CommonImagePreview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            delayedVisible: false,
            imageError: false  
        };
        this.delayTimeout = null;
    }

    handleLoad = () => {
        this.setState({ loaded: true }, () => {
            this.delayTimeout = setTimeout(() => {
                this.setState({ delayedVisible: true });
            }, 300);
        });
    };

    componentWillUnmount() {
        if (this.delayTimeout) clearTimeout(this.delayTimeout);
    }

    render() {
        const {
            width = 80,
            height = 80,
            alt = "",
            className = "",
            style = {},
            src,
            ...rest
        } = this.props;

        const sizeStyle = {
            width: typeof width === "number" ? `${width}px` : width,
            height: typeof height === "number" ? `${height}px` : height,
        };

        const baseStyle = {
            ...sizeStyle,
            borderRadius: "50%",
            objectFit: "cover",
            display: this.state.delayedVisible ? "block" : "none",
            ...style,
        };

        const placeholderStyle = {
            ...sizeStyle,
            borderRadius: "50%",
            backgroundColor: "#EEE",
            border: "1px solid #DDD",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        };

        const shouldShowImage = src && !this.state.imageError;

    return (
            <>
            {shouldShowImage ? (
                <>
                    {/* placeholder while image is loading */}
                    {!this.state.delayedVisible && (
                        <div style={placeholderStyle}>
                        <i
                            className="fa-solid fa-image"
                            style={{ fontSize: "1.5rem", color: "#999" }}
                        ></i>
                        </div>
                    )}
                    <img
                        src={src}
                        alt={alt}
                        onLoad={this.handleLoad}
                        onError={() =>
                        this.setState({ imageError: true }, () =>
                            console.log("Image failed to load.")
                        )
                        }
                        className={className}
                        style={baseStyle}
                        {...rest}
                    />
                </>
            ) : (
                // if no src or image error
                <div style={placeholderStyle}>
                    <i
                        className="fa-solid fa-image"
                        style={{ fontSize: "1.5rem", color: "#999" }}
                    ></i>
                </div>
            )}
            </>
        );
    }

}

export default CommonImagePreview;
